import React, { FC} from 'react';
import {Box, BoxProps, CircularProgress} from '@mui/material';

export const LoadingSpinner: FC<BoxProps> = ({sx, ...props}) => (
  <Box
    data-testid="LoadingSpinner"
    sx={{
      p: 10,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}
    {...props}
  >
    <CircularProgress />
  </Box>
);
